import { Directive, Input, ElementRef, HostListener, OnInit } from '@angular/core';
import { TabService } from './TabService';
import { Subject } from 'rxjs';
type IKNOWISNUMBER = any;
type IKNOWISSTRING = any;

@Directive({
  selector: '[tabIndex]'
})
export class TabDirective implements OnInit {

  private _index: number;

  /**
   * This is a getter function that returns a value of type IKNOWISNUMBER for the index property.
   * @returns The `get` accessor method is returning the `_index` property, which is of type
   * `IKNOWISNUMBER`.
   */
  get index(): IKNOWISNUMBER {
    return this._index;
  }

  /* This is an input property decorator in Angular that allows the `index` property of the
  `TabDirective` class to be set from the parent component using the `tabIndex` attribute. The `set`
  method of the decorator takes in a string value (`i`) and sets the `_index` property of the class to
  the parsed integer value of `i`. This ensures that the `index` property is always a number, even if
  it is set as a string from the parent component. */
  @Input('tabIndex')
  set index(i: IKNOWISSTRING) {
    this._index = parseInt(i);
  }

  /* The `@HostListener` decorator is used to register an event listener on the host element of the
  directive. In this case, it is listening for the `keydown` event. When the event is triggered, the
  `onInput` function is called with the event object as a parameter (`e`). */
  @HostListener('keydown', ['$event'])
  onInput(e: any) {
    if (e.which === 13) {
      this.tabService.selectedInput.next(this.index + 1)
      e.preventDefault();
    }
  }

  /**
   * This is a constructor function that takes in an ElementRef and a TabService as parameters.
   * @param {ElementRef} el - The `el` parameter is an instance of the `ElementRef` class, which is a
   * wrapper around a native element in the DOM. It allows you to access the underlying native element
   * and its properties and methods.
   * @param {TabService} tabService - The `tabService` parameter is an instance of the `TabService`
   * class, which is likely a service that provides functionality related to managing tabs or tabbed
   * interfaces in the application. It is being injected into the constructor using Angular's dependency
   * injection system, which allows for easy management of dependencies between different
   */
  constructor(private el: ElementRef, private tabService: TabService) {
  }

  /**
   * This function subscribes to a selected input and focuses on the native element if the index matches.
   */
  ngOnInit() {
    this.tabService.selectedInput
      .subscribe((i) => {
        if (i === this.index) {
          this.el.nativeElement.focus();
        }
      });
  }
}